export default __webpack_public_path__ + "static/media/img_04.0f2d1079.jpg";